<div class="esl-quick-quote-tool">
  <lx-sales-communication-settings [argoIdentifier]="argoIdentifier" [clientName]="clientName"></lx-sales-communication-settings>
  <router-outlet (activate)="componentAdded($event)" (deactivate)="componentRemoved()"></router-outlet>
  <lx-argo-ids [argoIds]="formattedArgoIds" *ngIf="formattedArgoIds.length > 0"></lx-argo-ids>
  <lx-loading-spinner i18n-message message="Loading..." [loading]="loading" shadingColor="rgba(0,0,0,0.5)" [positionRelative]="true"></lx-loading-spinner>
</div>

<lx-toast-notification (errorEvent)="onError()"></lx-toast-notification>
<p-toast [key]="infoToastKey"></p-toast>
